import { CURRENCY_FORMAT } from "../../../../../utils/constants/appConstants";
import {
  capitalizeFirstLetter,
  formatDateWithDayjs,
  formatNumber
} from "../../../../../utils/utils";
export const COLUMNS = [
  {
    Header: "Customer",
    Footer: "Customer",
    accessor: "legal_name"
  },
  {
    Header: "FT No",
    Footer: "FT No",
    accessor: "FT_no"
  },
  {
    Header: "Total Owing",
    Footer: "Total Owing",
    accessor: "totalowing",
    Cell: ({ value }) => {
      const formatted = formatNumber(value);
      return formatted ? `${CURRENCY_FORMAT}${formatted}` : "";
    }
  },
  {
    Header: "Payment",
    Footer: "Payment",
    accessor: "amount"
  },
  {
    Header: "Owing at Repay Date",
    Footer: "Owing at Repay Date",
    accessor: "owing_repaydate",
    Cell: ({ value }) => {
      const formatted = formatNumber(value);
      return formatted ? `${CURRENCY_FORMAT}${formatted}` : "";
    }
  },
  {
    Header: "Owing Today",
    Footer: "Owing Today",
    accessor: "owing",
    Cell: ({ value }) => {
      const formatted = formatNumber(value);
      return formatted ? `${CURRENCY_FORMAT}${formatted}` : "";
    }
  },
  {
    Header: "Xero Status",
    Footer: "Xero Status",
    accessor: "xero_status",
    Cell: ({ value }) => capitalizeFirstLetter(value)
  },
  {
    Header: "GoCardless Status",
    Footer: "GoCardless Status",
    accessor: "gocardless_status",
    Cell: ({ value }) => capitalizeFirstLetter(value)
  },
  {
    Header: "FundTap Status",
    Footer: "FundTap Status",
    accessor: "status"
  },
  {
    Header: "Payment Date",
    Footer: "Payment Date",
    accessor: "payment_date",
    Cell: ({ value }) => formatDateWithDayjs(value, "DD-MMM-YYYY")
  },
  {
    Header: "Repayment Date",
    Footer: "Repayment Date",
    accessor: "repayment_date",
    Cell: ({ value }) => formatDateWithDayjs(value, "DD-MMM-YYYY")
  }
];
